import React from 'react';
import Box from '@material-ui/core/Box';
import { ButtonPrimaryLink } from '../../../shared/components/ui/buttons/Buttons';
import { PageTitle } from '../../../shared/components/ui/texts/Texts';

/**
 * Dashboard top info.
 *
 * @returns {JSX.Element} Dashoard header.
 */
export const ExperienceListHeader: React.FC = () => (
  <Box display="flex" justifyContent="space-between" alignItems="center">
    <PageTitle>Experiences</PageTitle>
    <ButtonPrimaryLink to="/experiences/add-experience">
      ADD EXPERIENCE
    </ButtonPrimaryLink>
  </Box>
);
